'use strict';
module.exports = require('./Rating.vue');